export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => null
    },
    onSubmit: {
      type: Function,
      required: false,
      default: () => null
    },
    onDelete: {
      type: Function,
      required: false,
      default: () => null
    }
  },
  data: () => ({
    errors: []
  }),
  methods: {
    cancel(route) {
      if (route) {
        this.$router.push(route)
      } else {
        this.$router.go()
      }
    },
    submit() {
      if (this.validate()) {
        if (this.onSubmit) {
          this.onSubmit(JSON.stringify(this.item), this.item.id)
        } else {
          this.$parent.update(this.item.id, JSON.stringify(this.item))
        }
      }
    }
  }
}
